import type { ReactNode, SVGProps } from "react";

export function ViewIcon(props: SVGProps<SVGSVGElement>): ReactNode {
	return (
		<svg
			fill="none"
			height="11"
			viewBox="0 0 16 11"
			width="16"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M6.06934 5.29164C6.06934 5.7042 6.23322 6.09986 6.52495 6.39158C6.81667 6.68331 7.21233 6.8472 7.62489 6.8472C8.03745 6.8472 8.43311 6.68331 8.72484 6.39158C9.01656 6.09986 9.18045 5.7042 9.18045 5.29164C9.18045 4.87908 9.01656 4.48342 8.72484 4.1917C8.43311 3.89997 8.03745 3.73608 7.62489 3.73608C7.21233 3.73608 6.81667 3.89997 6.52495 4.1917C6.23322 4.48342 6.06934 4.87908 6.06934 5.29164Z"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M14.625 5.29167C12.7583 8.40278 10.425 9.95833 7.625 9.95833C4.825 9.95833 2.49167 8.40278 0.625 5.29167C2.49167 2.18056 4.825 0.625 7.625 0.625C10.425 0.625 12.7583 2.18056 14.625 5.29167Z"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
		</svg>
	);
}
